import { collection, pubsub } from '@services';

class CollectionGrid extends HTMLElement {
  unsubscribers = [];
  abortController;

  static {
    collection.sections.push('main-collection');
  }

  connectedCallback() {
    // Subscribe to filters updated event
    this.unsubscribers.push(
      pubsub.subscribe('collection:filter:fetched', ({ sections }) => {
        const mainCollectionSection = sections.find(({ section }) => section === 'main-collection');
        if (!mainCollectionSection) return;

        this.replaceProductGrid(mainCollectionSection);
        this.updateFilterElements(mainCollectionSection);
        this.updateInfiniteLoadPagination(mainCollectionSection);
      })
    );
  }

  disconnectedCallback() {
    this.unsubscribers.forEach((unsubscriber) => unsubscriber());
  }

  replaceProductGrid(section) {
    const parsedCollectionGrid = section.html.querySelector('collection-grid');

    // Clone the element to avoid modifying the shared HTML object
    const clonedCollectionGrid = parsedCollectionGrid.cloneNode(true);

    this.innerHTML = clonedCollectionGrid.innerHTML;
  }

  updateFilterElements(section) {
    ['filter-count', 'filter-remove-links'].forEach((selector) => {
      const element = this.querySelector(selector);
      const source = section.html.querySelector(selector);
      if (element && source) element.innerHTML = source.innerHTML;
    });
  }

  /**
   * Update the parent infinite-load element's pagination data
   * @param {object} section - The fetched section containing the new pagination data
   */
  updateInfiniteLoadPagination(section) {
    const infiniteLoad = this.closest('infinite-load');
    if (!infiniteLoad) return;

    const sourceInfiniteLoad = section.html.querySelector('infinite-load');
    if (!sourceInfiniteLoad?.dataset?.paginate) return;

    infiniteLoad.dataset.paginate = sourceInfiniteLoad.dataset.paginate;
  }
}

customElements.define('collection-grid', CollectionGrid);
